import { render, staticRenderFns } from "./StorageCapCard.vue?vue&type=template&id=480f9b82&scoped=true"
import script from "./StorageCapCard.vue?vue&type=script&lang=ts"
export * from "./StorageCapCard.vue?vue&type=script&lang=ts"
import style0 from "./StorageCapCard.vue?vue&type=style&index=0&id=480f9b82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480f9b82",
  null
  
)

export default component.exports